import React, { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment-timezone";
import { useLocation } from "react-router-dom";
import Loader from "components/Loaders/Loader";
import { FaFilter, FaUserCircle } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "../../Leaderboard/LeaderBoard.css";
import {
  FaEnvelope,
  FaPhoneAlt,
  FaBuilding,
  FaGlobe,
  FaUsers,
  FaCity,
} from "react-icons/fa";
import {
  MdOutlineDeviceUnknown,
  MdOutlineNotificationsActive,
} from "react-icons/md";
import { useCheckSessionHeartBeat } from "components/API/ApiEnpoints";

const PublicLeaderboard: React.FC = () => {
  useCheckSessionHeartBeat();
  const { state } = useLocation();
  const { group_uid, group_name } = state || {};

  const [leaderboard, setLeaderboard] = useState<any[]>([]);
  const today = new Date();
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);

  const [duration, setDuration] = useState("weekly");
  const [filterType, setFilterType] = useState("steps");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  const beAddress = process.env.REACT_APP_API_URL;
  const sessionUid = localStorage.getItem("session_uid") || "";
  const userUid = localStorage.getItem("user_uid") || "";
  const [isProfilePopupOpen, setIsProfilePopupOpen] = useState(false);
  const [selectedUserProfile, setSelectedUserProfile] = useState<any>(null);
  const [userImages, setUserImages] = useState<{
    [key: string]: string | null;
  }>({});
  const [tempFromDate, setTempFromDate] = useState(fromDate);
  const [tempToDate, setTempToDate] = useState(toDate);
  const [tempFilterType, setTempFilterType] = useState(filterType);

  const topThreeRaw = leaderboard.slice(0, 3);
  const topThree = [...topThreeRaw];

  for (let i = topThree.length; i < 3; i++) {
    topThree.push({
      user_uid: `placeholder-${i}`,
      user_name: "Not yet claimed",
      value: "--",
      unit: "",
      image: null,
    });
  }

  const loggedInUserIndex = leaderboard.findIndex(
    (entry) => entry.user_uid === userUid
  );
  const loggedInUser =
    loggedInUserIndex !== -1 ? leaderboard[loggedInUserIndex] : null;
  const isInTop3 = loggedInUserIndex > -1 && loggedInUserIndex < 3;

  let rest = leaderboard.slice(3).filter((entry) => entry.user_uid !== userUid);

  for (let i = leaderboard.length; i < 5; i++) {
    rest.push({
      user_uid: `placeholder-${i}`,
      user_name: "Not yet claimed",
      value: "--",
      unit: "",
      image: null,
    });
  }
  useEffect(() => {
    const now = moment();
    let from: Date, to: Date;

    if (duration === "daily") {
      from = now.startOf("day").toDate();
      to = now.endOf("day").toDate();
    } else if (duration === "weekly") {
      from = now.startOf("isoWeek").toDate();
      const endOfWeek = now.endOf("isoWeek").toDate();
      const today = new Date();
      to = endOfWeek > today ? today : endOfWeek;
    } else {
      from = now.startOf("month").toDate();
      const endOfMonth = now.endOf("month").toDate();
      const today = new Date();
      to = endOfMonth > today ? today : endOfMonth;
    }

    // Set dates first
    setFromDate(from);
    setToDate(to);
  }, [duration]);

  useEffect(() => {
    if (fromDate && toDate) {
      fetchLeaderboard(fromDate, toDate, duration, filterType);
    }
  }, [fromDate, toDate]);

  useEffect(() => {
    if (isPopupOpen) {
      setTempFromDate(fromDate);
      setTempToDate(toDate);
      setTempFilterType(filterType);
    }
  }, [isPopupOpen]);

  const fetchUserProfile = async (user_uid: string) => {
    try {
      const userImage = userImages[user_uid] || null;

      const response = await axios.get(`${beAddress}/api/public-user-profile`, {
        headers: {
          "user-uid": userUid,
          "Content-Type": "application/json",
        },
        params: {
          target_user_uid: user_uid,
        }, withCredentials: true,
      });

      if (
        response.data.status === "Success" &&
        typeof response.data.data === "object"
      ) {
        const userData = response.data.data;
        userData.image = userImage;
        setSelectedUserProfile(userData);
        setIsProfilePopupOpen(true);
      } else {
        console.error("Invalid profile response");
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };

  // useEffect(() => {
  //   const now = moment.utc();
  //   let from: Date, to: Date;

  //   if (duration === "daily") {
  //     from = now.startOf("day").toDate();
  //     to = now.endOf("day").toDate();
  //   } else if (duration === "weekly") {
  //     from = now.startOf("isoWeek").toDate();
  //     to = now.endOf("isoWeek").toDate();
  //   } else {
  //     from = now.startOf("month").toDate();
  //     to = now.endOf("month").toDate();
  //   }

  //   setFromDate(from);
  //   setToDate(to);

  //   // Fetch after setting
  //   fetchLeaderboard(from, to, duration, filterType);
  // }, [duration, filterType]);

  const fetchLeaderboard = async (
    fromDateOverride = fromDate,
    toDateOverride = toDate,
    currentDuration = duration,
    currentFilter = filterType
  ) => {
    setLoading(true);
    try {
      const from = moment(fromDateOverride).format("YYYY-MM-DD") + "T00:00:00Z";
      const to = moment(toDateOverride).format("YYYY-MM-DD") + "T00:00:00Z";

      const params: any = {
        from_datetime: from,
        to_datetime: to,
        target_user_uid: location.state?.target_user_uid,
      };

      if (currentFilter !== "overall_performance") {
        params.filter_type = currentFilter;
      }

      const response = await axios.get(
        `${beAddress}/api/get-hierarchy-leaderboard`,
        {
          headers: {
            "user-uid": userUid,
          }, withCredentials: true,
          params,
        }
      );

      if (response.data?.data) {
        const data = response.data.data;
        const imagesMap: { [key: string]: string | null } = {};

        data.forEach((member: any) => {
          if (
            member.image &&
            member.image !==
            "R0lGODlhAQABAIABAAAAAP///yH5BAEAAAEALAAAAAABAAEAAAICRAEAOw=="
          ) {
            imagesMap[
              member.user_uid
            ] = `data:image/png;base64,${member.image}`;
          } else {
            imagesMap[member.user_uid] = null;
          }
        });

        setUserImages(imagesMap);
        setLeaderboard(data);
      }
    } catch (err) {
      console.error("Error fetching leaderboard:", err);
    } finally {
      setLoading(false);
    }
  };
  const getStatusInfo = (status: string) => {
    switch (status) {
      case "active":
        return { color: "#16821aff", label: "Online", iconname: "checkcircle" }; // green 16821aff
      case "away":
        return { color: "#f6c70aff", label: "Away", iconname: "clockcircle" }; // yellow f6c70aff
      case "invited":
        return {
          color: "#000000",
          label: "Inactive",
          iconname: "exclamationcircle",
        }; // black
      default:
        return {
          color: "#9b9292ff",
          label: "Offline",
          iconname: "closecircle",
        }; // black
    }
  };

  // useEffect(() => {
  //   fetchLeaderboard();
  // }, [fromDate, toDate, filterType, duration]);

  return (
    <div className="leaderboard-container">
      <div className="leaderboard-title">{group_name} Leaderboard</div>

      <div className="duration-tabs-wrapper">
        <div className="filter-item" onClick={() => setIsPopupOpen(true)}>
          <FaFilter className="filter-icon" />
          <span>Filter By</span>
        </div>

        <div className="duration-tabs">
          {["daily", "weekly", "monthly"].map((d) => (
            <button
              key={d}
              className={`tab-button ${duration === d ? "active" : ""}`}
              onClick={() => setDuration(d)}
            >
              {d.charAt(0).toUpperCase() + d.slice(1)}
            </button>
          ))}
        </div>
      </div>

      {loading ? (
        <Loader />
      ) : (
        <>
          {/* Top 3 */}
          <div className="leaderboard-members-list">
            {topThree.map((member, index) => {
              const imageSrc = userImages[member.user_uid];

              return (
                <div
                  key={member.user_uid}
                  className={`leaderboard-member-card ${index === 0
                      ? "first-place"
                      : index === 1
                        ? "second-place"
                        : "third-place"
                    }`}
                  onClick={() => {
                    if (!member.user_uid.startsWith("placeholder")) {
                      fetchUserProfile(member.user_uid);
                    }
                  }}
                >
                  {imageSrc ? (
                    <img
                      src={imageSrc}
                      alt={member.user_name}
                      className="leaderboard-image"
                    />
                  ) : (
                    <FaUserCircle
                      style={{ fontSize: "100px", color: "gray" }}
                    />
                  )}

                  <div className="leaderboard-progress-circle">{index + 1}</div>
                  <div className="leaderboard-member-info">
                    <p className="leaderboard-name">{member.user_name}</p>
                    <span className="leaderboard-points">
                      {member.value} {member.unit}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Lower List */}
          <div className="leaderboard-list">
            {loggedInUser && !isInTop3 && (
              <div
                key="you-highlight"
                className="leaderboard-list-item you-highlight"
              >
                <div className="leaderboard-list-item1">
                  <div className="leaderboard-rank-list1">
                    {leaderboard.findIndex(
                      (entry) => entry.user_uid === loggedInUser.user_uid
                    ) + 1}
                  </div>
                  <div className="leadership-name-image-container">
                    {loggedInUser.image ? (
                      <img
                        src={`data:image/png;base64,${loggedInUser.image}`}
                        alt={loggedInUser.user_name}
                        className="leaderboard-list-image"
                      />
                    ) : (
                      <FaUserCircle
                        style={{ fontSize: "40px", color: "black" }}
                      />
                    )}
                    <p className="leaderboard-list-name">
                      {loggedInUser.user_name}{" "}
                      <span style={{ fontWeight: 500 }}>(You)</span>
                    </p>
                  </div>
                </div>
                <div className="leaderboard-list-points">
                  {loggedInUser.value}{" "}
                  {loggedInUser.unit === "count" ? "Steps" : loggedInUser.unit}
                </div>
              </div>
            )}
            {rest.map((member, index) => {
              const actualIndex = leaderboard.findIndex(
                (entry) => entry.user_uid === member.user_uid
              );
              const actualRank = actualIndex !== -1 ? actualIndex + 1 : "--";

              const imageSrc = userImages[member.user_uid];

              return (
                <div
                  key={member.user_uid}
                  className="leaderboard-list-item"
                  onClick={() => {
                    if (!member.user_uid.startsWith("placeholder")) {
                      fetchUserProfile(member.user_uid);
                    }
                  }}
                >
                  <div className="leaderboard-list-item1">
                    <div className="leaderboard-rank-list1">{actualRank}</div>
                    <div className="leadership-name-image-container">
                      {imageSrc ? (
                        <img
                          src={imageSrc}
                          alt={member.user_name}
                          className="leaderboard-list-image"
                        />
                      ) : (
                        <FaUserCircle
                          className="leaderboard-list-image"
                          style={{ fontSize: "100px", color: "gray" }}
                        />
                      )}

                      <p className="leaderboard-list-name">
                        {member.user_uid?.startsWith("placeholder")
                          ? "Not yet claimed"
                          : member.user_name}
                      </p>
                    </div>
                  </div>
                  <div className="leaderboard-list-points">
                    {member.user_uid?.startsWith("placeholder")
                      ? "--"
                      : `${member.value} ${member.unit === "count" ? "Steps" : member.unit
                      }`}
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
      {isPopupOpen && (
        <div className="leaderboard-popup">
          <div className="leaderboard-popup-content">
            <span
              className="leaderboard-close"
              onClick={() => setIsPopupOpen(false)}
            >
              &times;
            </span>
            <h2 className="leaderboard-popup-title">Filters</h2>

            <div className="leaderboard-filter-group">
              <label className="leaderboard-label">Select Metrics:</label>
              <select
                className="leaderboard-select"
                value={filterType}
                onChange={(e) => setTempFilterType(e.target.value)}
              >
                <option value="overall_performance">Overall Performance</option>
                <option value="steps">Steps</option>
                <option value="distance">Distance</option>
                <option value="caloriesburned">Calories Burned</option>
              </select>
            </div>

            <div className="leaderboard-filter-group">
              <label className="leaderboard-label">From Date:</label>
              <DatePicker
                selected={tempFromDate}
                onChange={(date) => {
                  const newFrom = date!;
                  setTempFromDate(newFrom);
                  if (tempToDate < newFrom) {
                    setTempToDate(newFrom);
                  }
                }}
                maxDate={new Date()}
                dateFormat="yyyy-MM-dd"
                className="leaderboard-datepicker"
              />
            </div>
            <div className="leaderboard-filter-group">
              <label className="leaderboard-label">To Date:</label>
              <DatePicker
                selected={tempToDate}
                onChange={(date) => setTempToDate(date!)}
                minDate={tempFromDate}
                maxDate={new Date()}
                dateFormat="yyyy-MM-dd"
                className="leaderboard-datepicker"
              />
            </div>

            <button
              className="leaderboard-apply-button"
              onClick={() => {
                setFromDate(tempFromDate);
                setToDate(tempToDate);
                setFilterType(tempFilterType);
                setIsPopupOpen(false);
                fetchLeaderboard(
                  tempFromDate,
                  tempToDate,
                  duration,
                  tempFilterType
                );
              }}
            >
              Apply
            </button>
          </div>
        </div>
      )}

      {isProfilePopupOpen && selectedUserProfile && (
        <div className="member-profile-popup">
          <div className="member-profile-popup-content">
            <span
              className="member-profile-close"
              onClick={() => setIsProfilePopupOpen(false)}
            >
              &times;
            </span>

            <div className="member-profile-header">
              {userImages[selectedUserProfile.user_uid] ? (
                <img
                  src={userImages[selectedUserProfile.user_uid] || undefined}
                  alt={`${selectedUserProfile.first_name} ${selectedUserProfile.last_name}`}
                  className="member-profile-image"
                  style={{
                    border: `3px solid ${getStatusInfo(selectedUserProfile.user_online_status)
                        .color
                      }`,
                    borderRadius: "50%",
                  }}
                />
              ) : (
                <FaUserCircle
                  className="member-profile-placeholder"
                  style={{
                    color: getStatusInfo(selectedUserProfile.user_online_status)
                      .color,
                    border: `3px solid ${getStatusInfo(selectedUserProfile.user_online_status)
                        .color
                      }`,
                    borderRadius: "50%",
                    padding: "3px",
                  }}
                />
              )}
              <div
                style={{
                  textAlign: "center",
                  marginTop: "2px",
                  fontWeight: "500",
                  color: getStatusInfo(selectedUserProfile.user_online_status)
                    .color,
                }}
              >
                {getStatusInfo(selectedUserProfile.user_online_status).label}
              </div>
              <div className="member-name-job">
                <h2>{`${selectedUserProfile.first_name} ${selectedUserProfile.last_name}`}</h2>
                <p className="member-job-title">
                  {selectedUserProfile.job_title}
                </p>
                <p
                  className={`status-label ${selectedUserProfile.user_status === "active"
                      ? "active"
                      : "inactive"
                    }`}
                >
                  {/* uncomment this if active inactive tag needed in modal */}
                  {/* {selectedUserProfile.user_status === "active" ? (
              <>
                <span className="dot green-dot" /> Active
              </>
            ) : (
              <>
                <span className="dot red-dot" /> Inactive
              </>
            )} */}
                </p>
              </div>
            </div>

            <div className="leaderboard-member-details">
              <div className="leaderboard-popup-row">
                <FaEnvelope className="leaderboard-popup-icon" />
                <div className="leaderboard-popup-text">
                  <div className="leaderboard-popup-label">Email:</div>
                  <div className="leaderboard-popup-value">
                    {selectedUserProfile.email}
                  </div>
                </div>
              </div>
              <div className="leaderboard-popup-row">
                <FaBuilding className="leaderboard-popup-icon" />
                <div className="leaderboard-popup-text">
                  <div className="leaderboard-popup-label">Department:</div>
                  <div className="leaderboard-popup-value">
                    {selectedUserProfile.department}
                  </div>
                </div>
              </div>
              <div className="leaderboard-popup-row">
                <FaPhoneAlt className="leaderboard-popup-icon" />
                <div className="leaderboard-popup-text">
                  <div className="leaderboard-popup-label">Mobile:</div>
                  <div className="leaderboard-popup-value">
                    {selectedUserProfile.mobile_phone || "-"}
                  </div>
                </div>
              </div>
              <div className="leaderboard-popup-row">
                <FaGlobe className="leaderboard-popup-icon" />
                <div className="leaderboard-popup-text">
                  <div className="leaderboard-popup-label">Nationality:</div>
                  <div className="leaderboard-popup-value">
                    {selectedUserProfile.nationality || "-"}
                  </div>
                </div>
              </div>
              <div className="leaderboard-popup-row">
                <FaCity className="leaderboard-popup-icon" />
                <div className="leaderboard-popup-text">
                  <div className="leaderboard-popup-label">City:</div>
                  <div className="leaderboard-popup-value">
                    {selectedUserProfile.city || "-"}
                  </div>
                </div>
              </div>
              <div className="leaderboard-popup-row">
                <MdOutlineDeviceUnknown className="leaderboard-popup-icon" />
                <div className="leaderboard-popup-text">
                  <div className="leaderboard-popup-label">Device type:</div>
                  <div className="leaderboard-popup-value">
                    {selectedUserProfile.device_type || "-"}
                  </div>
                </div>
              </div>
              <div className="leaderboard-popup-row">
                <MdOutlineNotificationsActive className="leaderboard-popup-icon" />
                <div className="leaderboard-popup-text">
                  <div className="leaderboard-popup-label">Last Active:</div>
                  <div className="leaderboard-popup-value">
                    {selectedUserProfile?.last_active
                      ? new Date(
                        selectedUserProfile.last_active
                      ).toLocaleString()
                      : "Never logged in"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PublicLeaderboard;
